import type React from 'react'

import type {
  SectionChangeHandler,
  SectionStats,
  SectionType,
} from '../../types'
import { StatCards, StatusBreakdown, StatusProgressBar } from './components'
import css from './styles.module.css'

interface Props {
  stats: SectionStats
  activeSection: SectionType
  changes: boolean
  comparison: string
  onSectionChange: SectionChangeHandler
}

export const ProjectStats: React.FC<Props> = ({
  stats,
  activeSection,
  changes,
  comparison,
  onSectionChange,
}) => {
  return (
    <div className={css.project_stats}>
      <div className={css.stat_card_group}>
        <StatCards
          stats={stats}
          activeSection={activeSection}
          changes={changes}
          comparison={comparison}
          onSectionChange={onSectionChange}
        />
      </div>
      <div className={css.status_progress_wrap}>
        <StatusProgressBar
          healthy={stats.healthy.count}
          warning={stats.warning.count}
          broken={stats.broken.count}
        />
      </div>

      <div className={css.status_breakdown_wrap}>
        <StatusBreakdown
          stats={stats}
          activeSection={activeSection}
          changes={changes}
          comparison={comparison}
          onSectionChange={onSectionChange}
        />
      </div>
    </div>
  )
}
